<template>
  <div class="auto-submit-cp3-1june">
      <img :src="autoSubmitImage" :class="innerWidth>991 ? 'auto-submit-img' : ''">
        <div class="right-align">
            <v-btn @click="onClose({status:false, isCloseAutoSubmit:true})" class="right-btn cust-btn" color="primary">OK</v-btn>
        </div>
  </div>
</template>

<script>

export default {
  name: "TabSwitchPopup",
  props: ["data", "onClose"],
  data() {
    return{
      innerWidth:""
    }
  },
  methods: {},
  mounted(){
    this.innerWidth=window.innerWidth;
  },
  computed:{
    autoSubmitImage(){
      if(this.data && this.data.noOfTimesTabChanged===1){
        return require("@/assets/img/FirstWarning.jpg")
      }
      else if(this.data && this.data.noOfTimesTabChanged===2){
        return require("@/assets/img/SecondWarning.jpg")
      }
      else if(this.data && this.data.noOfTimesTabChanged===3){
        return require("@/assets/img/LastWarning.jpg")
      }
    }
  }
};
</script>
